import * as yup from 'yup';

export const CheckboxTextSchema = yup.object({
  checked: yup.boolean().default(false),
  note: yup.mixed().when('checked', {
    is: true,
    then: yup.string().required('Beschreibung erforderlich'),
    otherwise: yup.string().optional().nullable(true),
  }),
});

export type ICheckboxText = yup.InferType<typeof CheckboxTextSchema>;

export const CheckboxValueSchema = yup.object({
  value: yup.array().of(yup.string().nullable()).nullable(),
});

export type ICheckboxValue = { value: string[] };

export const CheckboxWithTextSchema = yup.object({
  selected: yup.boolean().optional().default(false),
  text: yup.string().notRequired().nullable(),
});

export const CheckboxWithOptionalTextSchema = yup.object({
  selected: yup.boolean().optional().default(false),
  text: yup.string().notRequired().nullable(),
});

export type ICheckboxWithText = yup.InferType<typeof CheckboxWithTextSchema>;

export const CheckboxSchema = yup.object({
  selected: yup.boolean().optional().default(false),
});

export type ICheckbox = yup.InferType<typeof CheckboxSchema>;

export const CheckboxWithTextNumberSchema = yup.object({
  selected: yup.boolean().optional().default(false),
  text: yup.string().notRequired().nullable(),
  number: yup.number().notRequired().nullable(),
});

export type ICheckboxWithTextNumber = yup.InferType<typeof CheckboxWithTextNumberSchema>;
